import Entity from 'lib/Entity';
import { cloneDeep } from 'lodash';
import Reactions from 'collections/Reactions';

export default class ReactionSummary extends Entity {
  defaults() {
    return {
      version: 0,
      reactions: new Reactions(),
    };
  }

  parse(response: any): any {
    const reactionSummary = cloneDeep(response);

    reactionSummary['reactions'] = Reactions.fromJSON(reactionSummary['reactions']);

    return reactionSummary;
  }

  getReactions(): Reactions {
    return this.get('reactions');
  }

  getVersion(): number {
    return this.get('version');
  }

  getMessageUuid(): string {
    return this.get('message_uuid');
  }

  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ReactionSummaryGQL'.
  toGraphQL(): ReactionSummaryGQL {
    return {
      __typename: 'ReactionSummary',
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'toGraphQL' does not exist on type 'React... Remove this comment to see the full error message
      reactions: this.getReactions().map((r) => r.toGraphQL()),
      version: this.getVersion(),
      messageUuid: this.getMessageUuid(),
    };
  }
}
